/*
 *   Copyright (c) 2021 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { AUTH_REDUCER } from "../constants/enums";

const defaultState: any = {
  token: "",
  username: "",
  mobile: "",
  email: "",
  password: "",
  toastMessage: "",
  firstName: "",
  lastName: "",
  displayName: "",
  profileImageURL: "",
  type: "B2B",
  currentIndustry: "",
  businessUnitsList: [],
  currentBusinessUnit: "",
  currentBusinessUnitName: "",
  company: "",
  currentBusinessUnitLocation: "",
  errorMessage: "",
  currentBusinessUnitCountry: "",
  currentBusinessUnitAddress: {},
  userPermissions: [],
  customerLogo: "",
};

const initialState: any = {
  ...defaultState,
};

export default function (state = initialState, action: any): any {
  switch (action.type) {
    case AUTH_REDUCER.SET_TOAST:
      return {
        ...state,
        toastMessage: action.payload,
      };
    case AUTH_REDUCER.SET_USER_PERMISSIONS:
      return {
        ...state,
        userPermissions: action.payload,
      };
    case AUTH_REDUCER.START_LOGIN:
      return {
        ...state,
        password: "",
      };
    case AUTH_REDUCER.LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case AUTH_REDUCER.LOGOUT_SUCCESS:
      return defaultState;
    case AUTH_REDUCER.SET_USERNAME:
      return {
        ...state,
        username: action.payload,
      };
    case AUTH_REDUCER.SET_USER:
      return {
        ...state,
        ...action.payload,
      };
    case AUTH_REDUCER.SET_CURRENT_BUNIT:
      return {
        ...state,
        currentBusinessUnit: action.payload,
      };
    case AUTH_REDUCER.SET_BUNITS:
      return {
        ...state,
        businessUnitsList: action.payload,
      };
    case AUTH_REDUCER.SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case AUTH_REDUCER.SET_CUSTOMER_LOGO:
      return {
        ...state,
        customerLogo: action.payload,
      };
    case AUTH_REDUCER.AUTH_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
}
